import React from 'react';
import { ArrowRight, TrendingUp, ShieldCheck, PiggyBank } from 'lucide-react';
export function Hero() {
  return <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-emerald-50 to-white overflow-hidden" data-id="element-56">
      <div className="max-w-7xl mx-auto" data-id="element-57">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-58">
          <div className="space-y-8" data-id="element-59">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-100 text-emerald-800 rounded-full text-sm font-semibold" data-id="element-60">
              <span className="relative flex h-2 w-2" data-id="element-61">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" data-id="element-62"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" data-id="element-63"></span>
              </span>
              Investment Consulting for Beginners
            </div>

            <h1 className="text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight tracking-tight" data-id="element-64">
              Grow your wealth, <br data-id="element-65" />
              <span className="text-emerald-600" data-id="element-66">stress-free.</span>
            </h1>

            <p className="text-xl text-gray-600 max-w-lg leading-relaxed" data-id="element-67">
              We translate complex financial jargon into simple, actionable
              steps. Start your journey to financial freedom in Zakopane with
              guidance you can trust.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-68">
              <button className="inline-flex items-center justify-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-4 rounded-full font-semibold text-lg transition-all hover:shadow-xl hover:shadow-emerald-200 transform hover:-translate-y-1" data-id="element-69">
                Get Your Free Plan
                <ArrowRight className="h-5 w-5" data-id="element-70" />
              </button>
              <button className="inline-flex items-center justify-center gap-2 bg-white border-2 border-gray-200 hover:border-emerald-200 hover:bg-emerald-50 text-gray-700 px-8 py-4 rounded-full font-semibold text-lg transition-all" data-id="element-71">
                View Success Stories
              </button>
            </div>

            <div className="pt-4 flex items-center gap-4 text-sm text-gray-500" data-id="element-72">
              <div className="flex -space-x-2" data-id="element-73">
                {[1, 2, 3, 4].map(i => <div key={i} className="h-8 w-8 rounded-full bg-gray-200 border-2 border-white flex items-center justify-center text-xs font-bold text-gray-400" data-id="element-74">
                    {String.fromCharCode(64 + i)}
                  </div>)}
              </div>
              <p data-id="element-75">Trusted by 500+ beginners in Poland</p>
            </div>
          </div>

          <div className="relative lg:h-[600px] flex items-center justify-center" data-id="element-76">
            {/* Decorative blobs */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-emerald-200/30 rounded-full blur-3xl animate-pulse" data-id="element-77"></div>

            {/* Main Visual Composition */}
            <div className="relative w-full max-w-md aspect-square" data-id="element-78">
              {/* Central Card */}
              <div className="absolute inset-0 bg-white rounded-3xl shadow-2xl border border-gray-100 p-8 flex flex-col items-center justify-center text-center z-10 transform transition-transform hover:scale-105 duration-500" data-id="element-79">
                <div className="h-20 w-20 bg-emerald-100 rounded-2xl flex items-center justify-center mb-6" data-id="element-80">
                  <TrendingUp className="h-10 w-10 text-emerald-600" data-id="element-81" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-82">
                  Steady Growth
                </h3>
                <p className="text-gray-500" data-id="element-83">
                  Consistent returns over time with low-risk strategies.
                </p>
                <div className="mt-6 w-full bg-gray-100 h-2 rounded-full overflow-hidden" data-id="element-84">
                  <div className="h-full bg-emerald-500 w-3/4 rounded-full" data-id="element-85"></div>
                </div>
                <div className="mt-2 flex justify-between w-full text-sm font-medium" data-id="element-86">
                  <span className="text-gray-500" data-id="element-87">Portfolio</span>
                  <span className="text-emerald-600" data-id="element-88">+12.4%</span>
                </div>
              </div>

              {/* Floating Elements */}
              <div className="absolute -top-6 -right-6 bg-white p-4 rounded-2xl shadow-xl border border-gray-50 z-20 animate-bounce" style={{
              animationDuration: '3s'
            }} data-id="element-89">
                <div className="flex items-center gap-3" data-id="element-90">
                  <div className="bg-blue-100 p-2 rounded-lg" data-id="element-91">
                    <ShieldCheck className="h-6 w-6 text-blue-600" data-id="element-92" />
                  </div>
                  <div data-id="element-93">
                    <p className="text-xs text-gray-500 font-medium" data-id="element-94">
                      Risk Level
                    </p>
                    <p className="text-sm font-bold text-gray-900" data-id="element-95">
                      Conservative
                    </p>
                  </div>
                </div>
              </div>

              <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-2xl shadow-xl border border-gray-50 z-20 animate-bounce" style={{
              animationDuration: '4s'
            }} data-id="element-96">
                <div className="flex items-center gap-3" data-id="element-97">
                  <div className="bg-orange-100 p-2 rounded-lg" data-id="element-98">
                    <PiggyBank className="h-6 w-6 text-orange-600" data-id="element-99" />
                  </div>
                  <div data-id="element-100">
                    <p className="text-xs text-gray-500 font-medium" data-id="element-101">
                      Savings Goal
                    </p>
                    <p className="text-sm font-bold text-gray-900" data-id="element-102">
                      10,000 PLN
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}